var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8173 6.0339C15.2026 6.03399 15.5149 6.34642 15.5148 6.73173L15.5118 19.3024C15.5117 19.6877 15.1993 19.9999 14.814 19.9999C14.4287 19.9998 14.1164 19.6873 14.1165 19.302L14.1195 6.73141C14.1196 6.34609 14.432 6.03381 14.8173 6.0339Z",
    fill: "#210F32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.85214 14.7791C10.11 14.4928 10.5512 14.4698 10.8375 14.7276L14.8364 18.3297L18.8354 14.7276C19.1217 14.4698 19.5628 14.4928 19.8207 14.7791C20.0785 15.0654 20.0555 15.5065 19.7692 15.7644L15.3033 19.787C15.0379 20.0261 14.6349 20.0261 14.3695 19.787L9.9036 15.7644C9.6173 15.5065 9.59427 15.0654 9.85214 14.7791Z",
    fill: "#210F32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.697669C0 0.312357 0.312357 0 0.69767 0H18.8515C19.2368 0 19.5491 0.312357 19.5491 0.697669C19.5491 1.08298 19.2368 1.39534 18.8515 1.39534H0.69767C0.312357 1.39534 0 1.08298 0 0.697669Z",
    fill: "#210F32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.73156C0 6.34625 0.312357 6.03389 0.69767 6.03389H9.77457C10.1599 6.03389 10.4722 6.34625 10.4722 6.73156C10.4722 7.11687 10.1599 7.42923 9.77457 7.42923H0.69767C0.312357 7.42923 0 7.11687 0 6.73156Z",
    fill: "#210F32"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.7711C0 13.3858 0.312357 13.0734 0.69767 13.0734H5.74039C6.1257 13.0734 6.43806 13.3858 6.43806 13.7711C6.43806 14.1564 6.1257 14.4688 5.74039 14.4688H0.69767C0.312357 14.4688 0 14.1564 0 13.7711Z",
    fill: "#210F32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortBlack);
export default __webpack_public_path__ + "static/media/sort-black.24558f315f3aae30322d4462c3899d82.svg";
export { ForwardRef as ReactComponent };